import React, { useRef, useState } from 'react';
import classNames from 'clsx';
import Close from '@material-ui/icons/Close';

import { BadgeProps } from './Badge.interface';
import { useStyles } from './Badge.styles';

export default function Badge({
  className,
  label,
  readonly,
  onClick,
  onDelete,
  onFocus,
  ...props
}: BadgeProps) {
  const classes = useStyles();
  const [focus, setFocus] = useState<boolean>(false);

  const ref = useRef<HTMLDivElement>(document.createElement('div'));

  return (
    <div
      className={classNames(
        classes.root,
        {
          [classes.focus]: focus,
        },
        className
      )}
      ref={ref}
      onClick={(e) => {
        if (readonly) return;
        setFocus(true);
        setTimeout(() => {
          if (ref && ref.current) {
            ref.current.focus();
          }
        }, 0);
        onClick && onClick(e);
      }}
      onFocus={onFocus}
      onBlur={() => setFocus(false)}
      {...props}
      tabIndex={0}
    >
      <div className={classes.label}>{label}</div>
      {!readonly && (
        <Close
          className={classes.closeIcon}
          onClick={(e) => {
            e.stopPropagation();
            onDelete(e);
          }}
        />
      )}
    </div>
  );
}
